import * as React from "react";
import * as ReactDOM from "react-dom";

import {CssBaseline} from '@material-ui/core'
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import './App.css';
import * as serviceWorker from './serviceWorkerRegistration';

ReactDOM.render(
   <Provider store={store}>
      {/* for override remote css */}
      <CssBaseline /> 
      <App />
   </Provider>,
 document.getElementById("root"));

 serviceWorker.register();